// global window:true
import { v4 as uuid } from "uuid";
import Uri from "./uri";
import { fetch } from "./fetch";
import authorizationStore from "./authorizationStore";
import envConfig from "../../../envConfig.json"

const httpVerb = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

const status = {
  OK: 200,
  BAD_REQUEST: 400,
};

const contentType = "application/json";


const mergeHeaders = async (customHeaders, isAuthorized = true) => {
  // Stage
  // const xClientId = { "X-ClientId": "wqHfSj0JT2HgyoBoG3XTCr28PAiJa22Y" };
  // Prod
  const xClientId = { "X-ClientId": envConfig.GRAPHQL_X_CLIENTID };
  const token = !isAuthorized ? null : await authorizationStore.getToken();
  const bearer =
    token && isAuthorized ? { Authorization: `Bearer ${token}` } : {};
  const xCorrelationId = { "X-CorrelationId": uuid() };
  return Object.assign(
    { Accept: "application/json" },
    bearer,
    xClientId,
    xCorrelationId,
    customHeaders
  );
};

const performFetch = async (url, method, body, customHeaders = {}) => {
  const headers = await mergeHeaders(customHeaders);
  //Logger.logInfo(`Fetching ${url} from ${global.window.location.origin}`, null, headers['X-CorrelationId']);
  return await fetch(url, { method, headers, body });
};

const shouldReject = (response) => response.status >= status.BAD_REQUEST;

// const shouldRejectGraphql = (response) =>
//   response.status >= status.BAD_REQUEST ||
//   (response.errors && response.errors.length > 0);

const extractStatusAndBody = (resp) => {
  console.log(resp);
  const status = resp.status;
  return resp.json().then((body) => ({ status: status, body }));
};

const resultForStatus = (result) => {
  if (shouldReject(result)) {
    return Promise.reject(result);
  }
  return result;
};

// const resultForStatusGraphql = (result) => {
//   console.log("resultForStatusGraphql");
//   console.log(result);
//   if (shouldRejectGraphql(result)) {
//     return Promise.reject(result);
//   }
//   return result;
// };

const resultWithNoSuccessBody = (response) => {
  if (shouldReject(response)) {
    return extractStatusAndBody(response).then(resultForStatus);
  }
  if (response.headers && response.headers.get("Location")) {
    return {
      status: response.status,
      location: response.headers.get("Location"),
    };
  }
  return { status: response.status };
};

const getRequest = (url, params) => {
  const urlWithParams = Uri.withParams(url, params);
  return performFetch(urlWithParams, httpVerb.GET)
    .then(extractStatusAndBody)
    .then(resultForStatus);
};

const requestWithBody = (verb, url, body, params = {}, headers = {}) => {
  const urlWithParams = Uri.withParams(url, params);

  return performFetch(urlWithParams, verb, body, headers)
    .then(resultWithNoSuccessBody)
    .then(resultForStatus);
};

const deleteRequest = (url, params) => {
  const urlWithParams = Uri.withParams(url, params);
  return performFetch(urlWithParams, httpVerb.DELETE).then(
    resultWithNoSuccessBody
  );
};

const requestWithJson = (verb) => (url, body, params) => {
  const customHeaders = { "Content-Type": contentType };
  return requestWithBody(
    verb,
    url,
    JSON.stringify(body),
    params,
    customHeaders
  );
};

const graphqlRequest = async (url, query) => {
  const customHeaders = { "Content-Type": contentType };
  const body = JSON.stringify({
    query,
  });

  return await performFetch(
    `${url}graphql`,
    httpVerb.POST,
    body,
    customHeaders
  ).then(extractStatusAndBody);
  //.then(resultForStatusGraphql);
};

const request = {
  get: getRequest,
  put: requestWithJson(httpVerb.PUT),
  post: requestWithJson(httpVerb.POST),
  delete: deleteRequest,
  graphqlRequest,
  performFetch,
};

export default request;
